import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutMovement, WorkoutMovementWrite } from 'types';
import { client } from 'utils/api-client';

interface IUpdateWorkoutBenchmark {
  benchmarkId: string;
  data: WorkoutMovementWrite;
}

export default function useUpdateWorkoutBenchmark(): UseMutationResult<
  AxiosResponse<WorkoutMovement>,
  AxiosError<ErrorMessage>,
  IUpdateWorkoutBenchmark
> {
  const queryClient = useQueryClient();

  const updateWorkoutBenchmark = ({
    benchmarkId,
    data,
  }: IUpdateWorkoutBenchmark): Promise<AxiosResponse<WorkoutMovement>> => {
    return client.put(`workout-movements/${benchmarkId}/`, data);
  };

  return useMutation(updateWorkoutBenchmark, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutBenchmarks');
    },
  });
}
